// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"231":"b8ad5db3","299":"e43faa2c","673":"31d6cfe0","706":"ced77112","724":"b74a5654","830":"ced77112","879":"31d6cfe0","943":"31d6cfe0","982":"31d6cfe0"}[chunkId] + ".chunk.css";
};